import { render, staticRenderFns } from "./supplierMessage.vue?vue&type=template&id=7478343d&"
import script from "./supplierMessage.vue?vue&type=script&lang=js&"
export * from "./supplierMessage.vue?vue&type=script&lang=js&"
import style0 from "./supplierMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports